'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'expand';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f065';
var svgPathData = 'M144 32l16 0 0 32-128 0 0 128-32 0 0-160 144 0zM0 336l0-16 32 0 0 128 128 0 0 32-160 0 0-144zM432 32l16 0 0 160-32 0 0-128-128 0 0-32 144 0zM416 336l0-16 32 0 0 160-160 0 0-32 128 0 0-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faExpand = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;